import React from "react";

const DragDropFile = (props) => {
  // drag state
  const [dragActive, setDragActive] = React.useState(false);
  // ref
  const inputRef = React.useRef(null);

  // handle drag events
  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  // triggers when file is dropped
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    // if (e.dataTransfer.files && e.dataTransfer.files[0]) {
    if (e) {
      props.handleFileDrop(e, props.name);
    }
  };

  // triggers when file is selected with click
  const handleChange = function (e) {
    e.preventDefault();
    if (e) {
      props.handleChange(e);
    }
  };

  // triggers the input when the button is clicked
  const onButtonClick = () => {
    inputRef.current.click();
  };

  return (
    <div className="drag-drop-upload">
      <form
        id="form-file-upload"
        onDragEnter={handleDrag}
        onSubmit={(e) => e.preventDefault()}
      >
        <input
          name={props.name}
          ref={inputRef}
          type="file"
          id="input-file-upload"
          multiple={props.multiple}
          onChange={(e) => handleChange(e)}
          accept={props.accept}
        />
        <label
          id="label-file-upload"
          htmlFor="input-file-upload"
          className={dragActive ? "drag-active" : ""}
        >
          {props.iconPreview ? (
            <div>
              <img
                src={props.iconPreview}
                alt="file preview"
                className="file-preview"
                style={{ width: "10vh", height: "auto" }}
              />
              <p>{props.fileName}</p>
            </div>
          ) :
            <div>
              <p>Drag and drop your file here or</p>
              <button className="upload-button" onClick={onButtonClick}>
                Upload a file
              </button>
              <div>Accepts only {props.accept?.replace(/image/g, "")}</div>
            </div>
          }
        </label>
        {dragActive && (
          <div
            id="drag-file-element"
            htmlFor="input-file-upload"
            onDragEnter={handleDrag}
            onDragLeave={handleDrag}
            onDragOver={handleDrag}
            onDrop={handleDrop}
          ></div>
        )}
      </form>
      {/* {props.files && props.files?.map((file) => <p>{file.name}</p>)} */}
      {props.files && (
        <p className="mt-2">{props.files.length} file selected!!</p>
      )}
    </div>
  );
};

export default DragDropFile;
